import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ToggleSwitch from "../../common/ToggleSwitch";
import SectionsList from "./SectionList";
import ItemsList from "./ItemList";
import withStyledSystem from "../../hoc/WithStyledSystem";
import {
  fetchSectionsData,
  fetchItemsData,
  updateSectionItemsOrderAction,
} from "../../../redux/actions/careplanActions";
import "./CarePlanBuilder.css";

const WSToggleSwitch = withStyledSystem(ToggleSwitch);
const WSSectionsList = withStyledSystem(SectionsList);
const WSItemsList = withStyledSystem(ItemsList);

const CarePlanBuilder = () => {
  const dispatch = useDispatch();
  const { sections, items, sectionsLoaded, itemsLoaded, loading } = useSelector(
    (state) => state.careplan
  );

  const [activeTab, setActiveTab] = useState("sections");
  // const [sections, setSections] = useState([]);
  // const [items, setItems] = useState([]);

  // ************
  useEffect(() => {
    if (!sectionsLoaded) {
      dispatch(fetchSectionsData()); // Fetch sections only if not already loaded
    }
    if (!itemsLoaded) {
      dispatch(fetchItemsData()); // Fetch items only if not already loaded
    }
  }, [sectionsLoaded, itemsLoaded, dispatch]);

  const handleSectionUpdate = (sectionData) => {
    dispatch(
      updateSectionItemsOrderAction({
        section_id: sectionData.sectionId,
        items: sectionData.reorderedItems,
        isServiceUserSpecific: sectionData.isServiceUserSpecific,
      })
    );
    // dispatch(fetchItemsData({ forceRefresh: true })); // Re-fetch items from the server
    // dispatch(fetchSectionsData({ forceRefresh: true })); // Re-fetch items from the server
  };

  // Function to re-fetch items after a new item is added
  const handleItemsUpdated = (sectionId, reorderedItems) => {
    dispatch(
      updateSectionItemsOrderAction({
        sectionId: sectionId,
        reorderedItems: reorderedItems,
      })
    );
    dispatch(fetchItemsData({ forceRefresh: true })); // Re-fetch items from the server
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="care-plan-builder">
      <WSToggleSwitch activeTab={activeTab} setActiveTab={setActiveTab} />
      {sectionsLoaded && itemsLoaded ? ( //if sections and items are available
        activeTab === "sections" ? (
          <WSSectionsList
            sections={sections}
            items={items}
            onSectionUpdated={handleSectionUpdate}
          />
        ) : (
          <WSItemsList
            items={items}
            sections={sections}
            onItemsUpdated={handleItemsUpdated}
          />
        )
      ) : (
        <div>No data available</div>
      )}
    </div>
  );
};

export default CarePlanBuilder;
